export default "__VITE_ASSET__CLfFce_L__"